import { useEffect, useState } from "react";
import ServiceDebtPayModal from "../../../../shared/service-debt-pay-modal/ServiceDebtPayModal";
import { PackagesDataType } from "../../../../../interface/site.interface";
import MainButton from "../../../../shared/button/MainButton";
import styles from "./PackageItem.module.scss";
import { Base_Url } from "../../../../../constants/base_url";
import { formatDate } from "../../../../../extentions/date";
import addres from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Address Icon.svg";
import copy from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Copy.svg";
import copied from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/copied.png";
import country from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Country Icon.svg";
import delivery from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Delivery Icon.svg";
import invoice_file from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Invoice File Icon.svg";
import invoice_price from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Invoice Price Icon.svg";
import scales from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Scales.svg";
import status from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Status.svg";
import seller from "../../../../../assets/images/user-admin-panel/my-packages/card-detail-icons/Customs Status Icon.svg";
import CateGoryIcon from "../../../../../assets/images/user-admin-panel/Card/Address Icon.svg";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import TrackPackage from "../track-package/TrackPackage";
import UploadInvoie from "../upload-invoys/UploadInvoie";
import EditInvoie from "../edit-upload-invoys/EditInvoie";
import { useSite } from "../../../../../context/TranslationContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { OrdersService } from "../../../../../services/orders.service";
import { InvoiceService } from "../../../../../services/invoice.service";
import { toast } from "react-toastify";

interface PackageItemProps {
  pack: PackagesDataType;
  isChecked: boolean;
  idx: number;
  setCheckedCards: (value: number[] | ((prev: number[]) => number[])) => void;
  showEdit: boolean;
  setPaymentModalOpen: (value: boolean) => void;
  fetchPackages?: () => void;
  fetchPackagesType?: () => void;
  isPreDeclaration?: boolean;
}
interface Incoicedata {
  seller_id: undefined;
  category_id: undefined;
  currency_id: undefined;
  other_seller: "";
  price: "";
  title: string;
}

const PackageItem = ({
  pack,
  isChecked,
  idx,
  setCheckedCards,
  showEdit,
  setPaymentModalOpen,
  fetchPackages,
  fetchPackagesType,
  isPreDeclaration = false,
}: PackageItemProps) => {
  const [currentPack, setCurrentPack] = useState<PackagesDataType>(pack);
  const [copiedTextKey, setCopiedTextKey] = useState<string | null>(null);
  const [openFollowModal, setopenFollowModal] = useState<boolean>(false);
  const [packId, setPackId] = useState<number | null>(null);
  const [trackId, setTrackId] = useState<string>("");
  const [invoysModal, setInvoysModal] = useState(false);
  const [editInvoys, setEditInvoys] = useState(false);
  const [invoiceData, setInvoiceData] = useState<Incoicedata>({
    seller_id: undefined,
    category_id: undefined,
    currency_id: undefined,
    other_seller: "",
    price: "",
    title: "",
  });

  const [debtModalOpen, setDebtModalOpen] = useState(false);
  const countryId = currentPack.package_country_id;
  const toggleCardCheck = (id: number) => {
    setCheckedCards((prevCheckedCards: number[]) =>
      prevCheckedCards.includes(id)
        ? prevCheckedCards.filter((cardId) => cardId !== id)
        : [...prevCheckedCards, id]
    );
  };
  useEffect(() => {
    setCurrentPack(pack);
  }, [pack]);

  const copyToClipboard = (text: string, key: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedTextKey(key);
        setTimeout(() => setCopiedTextKey(null), 1000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const { data } = useSelector((state: RootState) => state.translationData);

  const handleInvoiceUploadSuccess = (newInvoiceDoc: string) => {
    setCurrentPack((prev) => ({
      ...prev,
      invoice_doc: newInvoiceDoc,
    }));
    fetchPackages?.();
    fetchPackagesType?.();
  };

  return (
    <div className={styles.package_card}>
      <div className={styles.card_head}>
        <div className={styles.head_left}>
          {!isPreDeclaration && pack.paid_status === 0 && (
            <div
              className={styles.checkbox}
              onClick={() => toggleCardCheck(pack.id)}
            >
              {isChecked && <div className={styles.checked_card}></div>}
            </div>
          )}
          <div className={styles.package_name_date}>
            <h1 className={styles.name}>
              {isPreDeclaration ? pack.tracking_code : pack.original_track}
            </h1>
            <p className={styles.date}>
              {isPreDeclaration ? pack.created_at : formatDate(pack.last_status_date)}
            </p>
          </div>
        </div>
        {/* {showEdit && (
          <MainButton
            className={styles.edit_btn}
            text="Düzəliş et"
            onClick={() => {
              setEditInvoys(true);
              setPackId(pack.id);
              setTrackId(pack.internal_track);
            }}
          />
        )} */}
      </div>
      <ul className={styles.package_detail_lists}>
        {isPreDeclaration ? (
          <>
            <li className={styles.detail_list}>
              <div className={styles.list_left}>
                <div className={styles.icon_box}>
                  <img src={seller} alt="seller" />
                </div>
                <div className={styles.title_subtitle}>
                  <p className={styles.title}>{data?.store}</p>
                  <p className={styles.subtitle}>{pack.seller}</p>
                </div>
              </div>
              <div className={styles.list_left}>
                <div className={styles.icon_box}>
                  <img src={CateGoryIcon} alt="category" />
                </div>
                <div className={styles.title_subtitle}>
                  <p className={styles.title}>{data?.auth_common_category}</p>
                  <p className={styles.subtitle}>{pack.category_name}</p>
                </div>
              </div>
            </li>
            <li className={styles.detail_list}>
              <div className={styles.list_left}>
                <div className={styles.icon_box}>
                  <img src={invoice_price} alt="price" />
                </div>
                <div className={styles.title_subtitle}>
                  <p className={styles.title}>{data?.auth_common_invoice_price}</p>
                  <p className={styles.subtitle}>
                    {pack.price} {pack.currency_icon}
                  </p>
                </div>
              </div>
              {pack.product_name && (
                <div className={styles.list_left}>
                  <div className={styles.icon_box}>
                    <img src={scales} alt="product" />
                  </div>
                  <div className={styles.title_subtitle}>
                    <p className={styles.title}>{"Məhsul adı"}</p>
                    <p className={styles.subtitle}>{pack.product_name}</p>
                  </div>
                </div>
              )}
            </li>
            {pack.remark && (
              <li className={styles.detail_list}>
                <div className={styles.list_left}>
                  <div className={styles.icon_box}>
                    <img src={addres} alt="remark" />
                  </div>
                  <div className={styles.title_subtitle}>
                    <p className={styles.title}>{"Qeyd"}</p>
                    <p className={styles.subtitle}>{pack.remark}</p>
                  </div>
                </div>
              </li>
            )}
            <li className={styles.detail_list}>
              <div className={styles.list_left}>
                <div className={styles.icon_box}>
                  <img src={invoice_file} alt="file" />
                </div>
                <div className={styles.title_subtitle}>
                  <p className={styles.title}>{data?.invoice}</p>
                </div>
              </div>
              {currentPack.invoice_doc ? (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`${Base_Url}/${currentPack.invoice_doc}`}
                  className={`${styles.status_btn} ${styles.faktura}`}
                >
                  {data?.auth_common_view_file}
                </a>
              ) : (
                <p className={`${styles.status_btn} ${styles.faktura}`}>—</p>
              )}
            </li>
          </>
        ) : (
          <>
        <li className={styles.detail_list}>
          <div className={styles.list_left}>
            <div className={styles.icon_box}>
              <img src={status} alt="status" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.status}</p>
            </div>
          </div>
          <div
            style={{ background: pack.status_color }}
            className={styles.status_btn}
          >
            {pack.status}
          </div>
        </li>
        <li className={styles.detail_list}>
          <div className={styles.list_left}>
            <div className={styles.icon_box}>
              <img src={country} alt="country" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.country}</p>
              <p className={styles.subtitle}>{pack.country_name}</p>
            </div>
          </div>
          <div className={styles.list_left}>
            <div
              className={styles.icon_box}
              style={{ cursor: "pointer" }}
              onClick={() =>
                copyToClipboard(pack.original_track, `${idx}-original_track`)
              }
            >
              <img src={seller} alt="seller" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.store}</p>
              <p className={styles.subtitle}>{pack.seller}</p>
            </div>
          </div>
        </li>
        <li className={styles.detail_list}>
          <div className={styles.list_left}>
            <div className={styles.icon_box}>
              <img src={scales} alt="scales" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.weight}</p>
              <p className={styles.subtitle}>
                {pack.displayed_weight} {pack.unit}
              </p>
            </div>
          </div>
          <div className={styles.list_left}>
            <div
              className={styles.icon_box}
              style={{ cursor: "pointer" }}
              onClick={() =>
                copyToClipboard(pack.internal_track, `${idx}-internal_track`)
              }
            >
              <img
                src={copiedTextKey === `${idx}-internal_track` ? copied : copy}
                alt="copy"
              />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>
                {data?.auth_common_internal_tracking}
              </p>
              <p className={styles.subtitle}>{pack.internal_track}</p>
            </div>
          </div>
        </li>
        <li className={styles.detail_list}>
          <div className={styles.list_left}>
            <div className={styles.icon_box}>
              <img src={CateGoryIcon} alt="addres" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.auth_common_category}</p>
              <p className={styles.subtitle}>{pack.category_name}</p>
            </div>
          </div>
          <div className={styles.list_left}>
            <div className={styles.icon_box}>
              <img src={invoice_price} alt="invoice_price" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.auth_common_invoice_price}</p>
              <p className={styles.subtitle}>
                {pack.invoice_price} {pack.invoice_price_icon}
              </p>
            </div>
          </div>
        </li>
        <li className={styles.detail_list}>
          <div className={styles.list_left}>
            <div className={styles.icon_box}>
              <img src={invoice_file} alt="file" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.invoice}</p>
            </div>
          </div>
          {currentPack.invoice_doc ? (
            <a
              target="_blank"
              rel="noreferrer"
              href={`${Base_Url}/${currentPack.invoice_doc}`}
              className={`${styles.status_btn} ${styles.faktura}`}
            >
              {data?.auth_common_view_file}
            </a>
          ) : (
            <p
              onClick={async () => {
                // 10 kq-dan ağır və ödənilməmiş bağlama: əvvəlcə ödəniş
                if (pack.declare_requires_payment) {
                  toast.error(
                    pack.declare_blocked_message ||
                      data?.declare_pay_first ||
                      "Zəhmət olmasa, əvvəlcə ödənişi edin."
                  );
                  return;
                }
                try {
                  const response = await InvoiceService.getPackagesUpdate(
                    currentPack.id
                  );
                  const data = response.data.original;
                  setInvoiceData({
                    category_id: data?.category_id,
                    currency_id: data?.currency_id,
                    other_seller: data?.other_seller,
                    price: data?.price,
                    seller_id: data?.seller_id,
                    title: data?.title,
                  });

                  if (response?.status === 200) {
                    setInvoysModal(true);
                    setTrackId(currentPack.internal_track);
                    setPackId(currentPack.id);
                  } else {
                    const errorMsg =
                      response?.data?.original?.content ||
                      "İnvoys məlumatı əldə edilə bilmədi.";
                    toast.error(errorMsg);
                  }
                } catch (err) {
                  toast.error(data?.error_occurred);
                }
              }}
              className={`${styles.status_btn} ${styles.faktura}`}
              style={{
                backgroundColor: pack.declare_requires_payment ? "#9e9e9e" : "red",
                cursor: pack.declare_requires_payment ? "not-allowed" : undefined,
              }}
              aria-disabled={pack.declare_requires_payment || undefined}
              title={pack.declare_requires_payment ? pack.declare_blocked_message || undefined : undefined}
            >
              {data?.auth_common_upload_invoice}
            </p>
          )}
        </li>

        <li className={styles.detail_list}>
          <div className={styles.list_left}>
            <div className={styles.icon_box}>
              <img src={delivery} alt="delivery" />
            </div>
            <div className={styles.title_subtitle}>
              <p className={styles.title}>{data?.delivery}</p>
              <div className={styles.price_container}>
                {pack.discount_color && (
                  <p
                    className={styles.subtitle}
                    style={{
                      color: pack.discount_color,
                      textDecoration: "line-through",
                    }}
                  >
                    {pack.delivery_original_amount}{" "}
                    {pack.package_delivery_amount_icon}
                  </p>
                )}

                <p className={styles.subtitle}>
                  {pack.discount_color
                    ? pack.discounted_amount
                    : pack.delivery_original_amount}{" "}
                  {pack.package_delivery_amount_icon}
                </p>
              </div>
            </div>
          </div>
          {pack.paid_status === 1 && pack.broker_debt_azn && pack.broker_debt_azn > 0 ? (
            <MainButton
              className={styles.payment_btn}
              text={`${data?.service_debt_badge || "Borc"}: ${Number(pack.broker_debt_azn).toFixed(2)} AZN`}
              onClick={() => setDebtModalOpen(true)}
            />
          ) : pack.paid_status === 1 ? (
            <MainButton className={styles.pay_now_btn} text={data?.paid} />
          ) : (
            <MainButton
              className={styles.payment_btn}
              text={data?.auth_pay}
              onClick={() => {
                setCheckedCards([pack.id]);
                setPaymentModalOpen(true);
              }}
            />
          )}
        </li>
          </>
        )}
      </ul>
      {!isPreDeclaration && (
      <button
        className={styles.watch_package_btn}
        onClick={() => {
          setopenFollowModal(true);
          setPackId(pack.id);
        }}
      >
        {data?.tracking_search}
      </button>
      )}

      {openFollowModal && (
        <GlobalModalComponent
          isOpen={openFollowModal}
          onClose={() => setopenFollowModal(false)}
        >
          <TrackPackage
            packId={packId}
            setopenFollowModal={setopenFollowModal}
          />
        </GlobalModalComponent>
      )}
      {invoysModal && (
        <GlobalModalComponent
          isOpen={invoysModal}
          onClose={() => setInvoysModal(false)}
        >
          <UploadInvoie
            trackId={trackId}
            packId={packId}
            onCloseModal={() => setInvoysModal(false)}
            onSuccess={handleInvoiceUploadSuccess}
            fetchPackagesType={fetchPackagesType}
            fetchPackages={fetchPackages}
            countryId={countryId}
            invoiceData={invoiceData}
          />
        </GlobalModalComponent>
      )}
      {editInvoys && (
        <GlobalModalComponent
          isOpen={editInvoys}
          onClose={() => setEditInvoys(false)}
        >
          <EditInvoie trackId={trackId} packId={packId} />
        </GlobalModalComponent>
      )}

      <ServiceDebtPayModal
        isOpen={debtModalOpen}
        onClose={() => setDebtModalOpen(false)}
        amountAzn={Number(pack.broker_debt_azn)}
        packageId={pack.id}
        onSuccess={() => {
          setDebtModalOpen(false);
          setCurrentPack((prev) => ({ ...prev, broker_debt_azn: 0 }));
          fetchPackages?.();
        }}
      />
    </div>
  );
};

export default PackageItem;
